import { useState } from "react";
import { History, RotateCcw } from "lucide-react";
import { toast } from "sonner";
import { http, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const toastIds = {};

const restore = async (eid, batch, reload) => {
  if (toastIds[batch]) { toast.dismiss(toastIds[batch]); delete toastIds[batch]; }
  try {
    const { data } = await http.post(`/episodes/${eid}/deleted-scenes/${batch}/restore`);
    toast.success(`${data.restored} scene(s) restored to their place`);
    await reload();
  } catch (e) { toast.error(errMsg(e)); }
};

export const undoToast = (eid, batch, label, reload) => {
  toastIds[batch] = toast.success(`${label} deleted`, { duration: 12000, action: { label: "Undo", onClick: () => restore(eid, batch, reload) } });
};

export const RecentlyDeleted = ({ ep, reload }) => {
  const [rows, setRows] = useState([]);
  const load = () => http.get(`/episodes/${ep.id}/deleted-scenes`).then((r) => setRows(r.data));
  return (
    <Popover onOpenChange={(o) => o && load()}>
      <PopoverTrigger asChild>
        <Button data-testid="recently-deleted-btn" size="sm" variant="ghost" className="rounded-full"><History className="w-3.5 h-3.5 mr-1.5" />Recently deleted</Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 bg-[#11141E] border-[#2A3245] space-y-2" data-testid="recently-deleted-panel">
        <div className="text-[11px] text-slate-400">Deleted scenes can be restored for 10 minutes.</div>
        {rows.length === 0 && <div className="text-sm text-slate-500" data-testid="recently-deleted-empty">Nothing deleted recently.</div>}
        {rows.map((b) => (
          <div key={b.batch_id} className="card-s p-2.5 flex items-center gap-2" data-testid={`deleted-batch-${b.batch_id}`}>
            <div className="flex-1 min-w-0 text-xs">
              <div className="truncate">{b.scenes.map((s) => `SC ${String(s.number).padStart(3, "0")}`).join(", ")}</div>
              <div className="text-[10px] text-slate-500 truncate">{b.scenes[0]?.heading} · {new Date(b.deleted_at).toLocaleTimeString()}</div>
            </div>
            <Button data-testid={`restore-batch-${b.batch_id}`} size="sm" variant="secondary" className="rounded-full"
              onClick={async () => { await restore(ep.id, b.batch_id, reload); load(); }}><RotateCcw className="w-3.5 h-3.5 mr-1" />Restore</Button>
          </div>
        ))}
      </PopoverContent>
    </Popover>
  );
};
